import React from 'react';
import styled, { css } from 'styled-components';
import { lighten, darken } from 'polished';
import Link from 'components/_utility/Link/Link';
import { minBp } from 'src/lib/theme';

export const buttonStyles = css`
  background-color: ${({ theme }) => theme.colors.buttons.default};
  color: ${({ theme }) => theme.colors.buttons.white};
  padding: 2px 30px 0;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  border: 0;
  height: 40px;
  transition: background-color 0.1s ease-in-out;
  justify-content: center;
  display: flex;
  align-items: center;
  line-height: 1;
  cursor: pointer;

  ${({ large }) =>
    large
      ? `
    height: 48px;
  `
      : ``}

  ${({ fluid }) =>
    fluid
      ? `
    width: 100%;
  `
      : ``}

  ${({ wide }) =>
    wide
      ? `
    width: 280px;
  `
      : ``}

  &:focus {
    background-color: #000;
  }

  &:hover:not(:disabled) {
    background: #505050;
  }

  &:disabled {
    cursor: default;
    background: #f4f4f4;
    color: #63656a;
    pointer-events: none;
  }

  ${({ primary, theme }) =>
    primary
      ? `
    background-color: ${theme.colors.buttons.primary};

    &:focus {
      // outline-offset: -0.125rem;
      background: #8F111F;
    }

    &:hover:not(:disabled) {
      background: #8F111F;
    }
  `
      : ``}

  @media ${minBp('tablet')} {
    font-size: 17px;
  }

  ${({ small }) =>
    small
      ? `
    font-size: 12px;
    height: 29px;

    @media ${minBp('tablet')} {
      font-size: 12px;
    }

    @media ${minBp('tabletLarge')} {
      font-size: 17px;
      height: 40px;
    }
  `
      : ``}
`;

const Button = styled.button`
  ${buttonStyles};
`;

export const LinkButton = styled(Link)`
  ${buttonStyles};
  display: inline-flex;
`;

export default Button;
